export type Vacuna = 'sputnik' | 'pfizer' | 'astrazeneca' | 'sinopharm'
export type Narrativa =
  | 'mejoraColectivaCercana'
  | 'mejoraColectivaLejana'
  | 'riesgoDelVirus'
  | 'riesgoDeLaVacuna'
export type Ente = 'gubernamental' | 'noGubernamental'

export type Combinacion = {
  id: string
  narrativa: Narrativa | ''
  narrativaText: string
  vacuna: Vacuna | ''
  vacunaText: string
  ente: Ente | ''
  enteText: string
}

export function getKeys<T extends string | number | symbol>(x: Record<T, any>) {
  return (Object.keys(x) as unknown) as T[]
}

const vacunas: Record<Vacuna, string> = {
  sputnik: 'Sputnik V (Rusia)',
  pfizer: 'de Pfizer-BioNTech (EE UU - Alemania)',
  astrazeneca: 'de Oxford-AstraZeneca (Inglaterra)',
  sinopharm: 'de Sinopharm (China)',
}

export const narrativas: Record<Narrativa, string> = {
  mejoraColectivaCercana: `Es importante vacunarnos contra el COVID-19 para minimizar el riesgo de contagio y así poder juntarnos con nuestros familiares y amigos.`,
  mejoraColectivaLejana: `Es importante vacunarnos contra el COVID-19 para minimizar el riesgo de contagio y así poder reanudar las clases, las actividades culturales y reactivar la economía sin colapsar el sistema de salud.`,
  riesgoDelVirus: `Es importante vacunarnos contra el COVID-19 para minimizar el riesgo de contagio y así evitar problemas de salud potencialmente graves.`,
  riesgoDeLaVacuna: `Es recomendable vacunarnos contra el COVID-19 ya que fueron demostradas científicamente la seguridad y la alta eficacia de la vacuna.`,
}

export const entes: Record<Ente, string> = {
  gubernamental: 'Imaginate que el Gobierno Nacional transmite este mensaje:',
  noGubernamental:
    'Imaginate que un grupo de profesionales de la salud independiente del Gobierno transmite este mensaje:',
}

export const combinaciones: Combinacion[] = getKeys(vacunas).flatMap(vacuna => {
  return getKeys(narrativas).flatMap(narrativa => {
    return getKeys(entes).map(ente => {
      return {
        id: `${vacuna}/${narrativa}/${ente}`,
        vacuna,
        vacunaText: vacunas[vacuna],
        narrativa,
        narrativaText: narrativas[narrativa],
        ente,
        enteText: entes[ente],
      }
    })
  })
})
